import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { iconoirAntenna, iconoirCpu, iconoirDashboardDots, iconoirGraphUp, iconoirShieldCheck } from '@ng-icons/iconoir';
import { TranslatePipe } from '@ngx-translate/core';
import { GetDemoComponent } from '@pyg-shared/get-demo/get-demo.component';

@Component({
  selector: 'app-platform',
  templateUrl: './platform.component.html',
  styleUrls: ['./platform.component.scss'],
  imports: [TranslatePipe, GetDemoComponent, NgIcon],
  providers: [provideIcons({ iconoirAntenna, iconoirCpu, iconoirDashboardDots, iconoirGraphUp, iconoirShieldCheck })],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlatformComponent {
  readonly pipelineSteps = [
    { icon: 'iconoirAntenna', labelKey: 'main_page.platform_teaser.step_collect' },
    { icon: 'iconoirCpu', labelKey: 'main_page.platform_teaser.step_process' },
    { icon: 'iconoirDashboardDots', labelKey: 'main_page.platform_teaser.step_deliver' },
    { icon: 'iconoirGraphUp', labelKey: 'main_page.platform_teaser.step_scale' },
  ];
}
